<mat-card appearance="outlined" class="mt-4 mb-4">
  <mat-card-header>
    <mat-card-title><b>Esito UVM</b></mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div *ngIf="data && data.disponibile === false" class="text-muted">
      {{ data.messaggio || 'Esito UVM non ancora disponibile.' }}
    </div>

    <div *ngIf="data && data.disponibile !== false">
      <strong>Sistema Richiedente:</strong> {{ data.sistemaRichiedente}}<br>
      <strong>Data Inizio:</strong> {{ data.dataInizio | date : "dd/MM/yyyy"}}<br>
      <strong>Data Fine:</strong> {{ data.dataFine | date : "dd/MM/yyyy"}}<br>
      <strong>Cod Profilo Cura:</strong> {{ data.codProfiloCura }}<br>
      <strong>Desc Profilo Cura:</strong> {{ data.descProfiloCura }}<br>
      <strong>Setting proposto:</strong> {{ data.setting.descrizione }}<br>

      <div class="mb-4"></div>


      <!--<strong class="mt-4">Allegati:</strong>

      <div *ngFor="let allegato of data.allegati" style="margin-left:20px" class="mb-4 mt-4">
        <strong>ID:</strong> {{ allegato.id }}<br>
        <strong>Descrizione:</strong> {{ allegato.descrizione }}<br>
      </div>-->


      <strong class="mt-4">Operatore(inviante)</strong><br>
      <div style="margin-left:20px" class="mb-4 mt-4">
        <strong>Nome:</strong> {{ data.operatore.nome }}<br>
        <strong>Cognome:</strong> {{ data.operatore.cognome }}<br>
        <strong>Codice Fiscale:</strong> {{ data.operatore.codiceFiscale }}<br>
        <strong>Descrizione:</strong> {{ data.operatore.qualifica.descrizione }}<br>

      </div>

      <strong class="mt-4">Interventi</strong>
      <div style="margin-left:20px" class="mt-4">

        <div *ngFor="let intervento of data.interventi">
          <strong>Cod Tipo Erogatore:</strong> {{ intervento.codTipoErogatore }}<br>
          <strong>Tipo Frequenza:</strong> {{ intervento.tipoFrequenza }}<br>
          <strong>Numero Accessi Previsti:</strong> {{ intervento.numeroAccessiPrevisti }}<br>

         
            <div *ngFor="let attivita of intervento.attivita" tyle="margin-left:20px">
              <strong>Attività:</strong> {{ attivita.descrizione }}  ({{ attivita.codice }})<br>
            </div>

            <hr>

        </div>


      </div>
    </div>




  </mat-card-content>
</mat-card>